import React from 'react';
import SupportArticleAccordion from './SupportArticleAccordion';
import SupportArticleBreak from './SupportArticleBreak';
import SupportArticleCallout from './SupportArticleCallout';
import SupportArticleDiagram from './SupportArticleDiagram';
import SupportArticleHeading from './SupportArticleHeading';
import SupportArticleIconList from './SupportArticleIconList';
import SupportArticleMediaGrid from './SupportArticleMediaGrid';
import SupportArticleReusableBlock from './SupportArticleReusableBlock';
import SupportArticleStepByStep from './SupportArticleStepByStep';
import SupportArticleTableOfContents from './SupportArticleTableOfContents';
import SupportArticleText from './SupportArticleText';
import SupportArticleVideo from './SupportArticleVideo';
import SupportArticleImage from './SupportArticleImage';
import SupportArticleDecisionTree from './SupportArticleDecisionTree';

const SupportArticleSectionTypes = {
  blockBuilderBreak: SupportArticleBreak,
  blockBuilderAccordion: SupportArticleAccordion,
  supportArticleMediaGrid: SupportArticleMediaGrid,
  supportArticleCallout: SupportArticleCallout,
  supportArticleDiagram: SupportArticleDiagram,
  supportArticleSectionHeading: SupportArticleHeading,
  supportArticleIconList: SupportArticleIconList,
  supportArticleStepByStep: SupportArticleStepByStep,
  supportArticleDecisionTree: SupportArticleDecisionTree,
  supportArticleTableOfContents: SupportArticleTableOfContents,
  supportArticleText: ({ section }) => {
    return <SupportArticleText text={section?.text} />;
  },
  frontMatterImage: ({ section }) => {
    return <SupportArticleImage image={section} />;
  },
  supportArticleVideo: SupportArticleVideo,
  supportArticleReusableBlock: SupportArticleReusableBlock,
};

export default SupportArticleSectionTypes;
